import React, { useState } from 'react';
import { Modal, Checkbox, Button, Tag, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import useNotify from '../../context/Notification/useNotify';
import IconPublicBanner from '../../assets/Images/icons/icon-public-banner';
import CustomizeBannerService from '../../services/CustomizeBanner.service';

export default function ModalPublic({
    open,
    handelClose,
    domainId,
    nextVersion,
    getHeaderDetail,
    bannerDetails,
    setChange
}) {
    const { t } = useTranslation();
    const [value, setValue] = useState(true);
    const [form] = Form.useForm();
    const notify = useNotify();

    const onChange = (e) => {
        if (e.target.checked) {
            setValue(true);
        } else {
            setValue(false);
        }
    };
    const onSubmit = async () => {
        const initialData = bannerDetails.getFieldValue();
        const customizeBanner = {
            IsPromptForShowPopupAgain: true,
            customizeContent: {
                ...initialData?.customizeContent,
                isDisplayCookiePolicy: initialData.isDisplayCookiePolicy,
                isDisplayPrivacyPolicy: initialData.isDisplayPrivacyPolicy,
                cookiePolicyUrlTh: initialData?.cookiePolicyUrlTh,
                cookiePolicyUrlEn: initialData?.cookiePolicyUrlEn,
                privacyPolicyUrlTh: initialData?.privacyPolicyUrlTh,
                privacyPolicyUrlEn: initialData?.privacyPolicyUrlEn,
                hyperLinkDisplayCookieNameEn:
                    initialData.hyperLinkDisplayCookieNameEn,
                hyperLinkDisplayCookieNameTh:
                    initialData.hyperLinkDisplayCookieNameTh,
                hyperLinkDisplayPrivacyNameEn:
                    initialData.hyperLinkDisplayPrivacyNameEn,
                hyperLinkDisplayPrivacyNameTh:
                    initialData.hyperLinkDisplayPrivacyNameTh,
            },
            customizeStyle: {
                hiddenLogo: initialData?.hiddenLogo || false,
                companyLogoId: initialData?.companyLogoId || null,
                fontFamily: initialData?.fontFamily || null,
                header: initialData?.header || null,
                description: initialData?.description || null,
                powerBy: initialData?.powerBy || null,
                hyperlink: initialData?.hyperlink || null,
                button: initialData?.button || null,
                backgroundThemeColor: initialData?.backgroundThemeColor || null,
                buttonThemeColor: initialData?.buttonThemeColor || null,
                acceptAllTh: initialData?.acceptAllTh || null,
                acceptAllEn: initialData?.acceptAllEn || null,
                changePreferenceTh: initialData?.changePreferenceTh || null,
                changePreferenceEn: initialData?.changePreferenceEn || null,
                rejectedAll: initialData?.rejectedAll || false,
                rejectedAllTh: initialData?.rejectedAllTh || null,
                rejectedAllEn: initialData?.rejectedAllEn || null,
                position: initialData?.position || null,
                closeable: initialData?.closeable || false,
                alwaysDisplay: initialData?.alwaysDisplay || false,
                positionIcon: initialData?.positionIcon || null,
                useDefaultIcon: initialData?.useDefaultIcon,
                iconColor: initialData?.iconColor || null,
                iconBackground: initialData?.iconBackground || null,
                iconCookieId: initialData?.iconCookieId || null,
                autoBlock3rdParty: initialData?.autoBlock3rdParty || false,
            },
        };

        if (!initialData?.useDefaultIcon && !initialData?.iconCookieId &&  document.querySelector('.ant-form-item-iconCookieId')) {
            document.querySelector('.ant-form-item-iconCookieId').scrollIntoView({ behavior: 'smooth' });
            form.setFields([
                {
                    name: 'iconCookieId',
                    errors: [t('errorText.requiredField')],
                },
            ]);
            return;
        }
        try {
            const { data } = await CustomizeBannerService.publicCookieBanner(
                domainId,
                customizeBanner
            );
            if (data?.resultCode === 1) {
                handelClose();
                getHeaderDetail();
                setChange(false);
                notify({
                    title: t('common.Success'),
                    description: t('Successfully to submitted'),
                });
            } else {
                handelClose();
                getHeaderDetail();
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submitted'),
                });
            }
        } catch (error) {
            handelClose();
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to submitted'),
            });
            console.log(error);
        }
        // handelClose()
    };
    return (
        <Modal
            width={500}
            className="_modal"
            footer={false}
            open={open}
            onCancel={() => {
                handelClose();
                form.resetFields();
            }}
        >
            <>
                <div className="flex flex-col justify-center items-center py-3 text-center">
                    <div className="py-4">
                        <IconPublicBanner />
                    </div>
                    <div className="text-[22px] py-2">
                        {t('COOKIE.PublicBanner')} ?
                    </div>
                    <div className="py-2">
                        <Tag
                            className="rounded-xl -my-1 text-center px-4 text-white"
                            color="#7B67FB"
                        >
                            {t('COOKIE.PublicVersion')}: {nextVersion || '0001'}
                        </Tag>
                    </div>
                    <div className="py-1 text-[#65707A]">
                        {t('COOKIE.PublicDetail')}
                    </div>
                </div>

                <Form
                    scrollToFirstError={{
                        behavior: 'smooth',
                        block: 'center',
                    }}
                    layout="vertical"
                    form={form}
                    onFinish={onSubmit}
                    initialValues={{ public: ['check'] }}
                >
                    <div className="flex flex-col space-y-4 justify-start items-center py-2 text-left">
                        <Form.Item name={'public'}>
                            <Checkbox.Group className="w-full">
                                <Checkbox
                                    key={'1'}
                                    value={'check'}
                                    style={{ lineHeight: '32px' }}
                                    onChange={onChange}
                                >
                                    {t('COOKIE.PublicCheck')}
                                </Checkbox>
                                <br />
                            </Checkbox.Group>
                        </Form.Item>
                    </div>
                    <div className="flex justify-center items-center py-4 space-x-4">
                        <Button
                            type="primary"
                            size="large"
                            className="w-32"
                            ghost
                            onClick={() => handelClose()}
                        >
                            {t('common.Cancel')}
                        </Button>
                        <Button
                            // loading={loading}
                            onClick={() => onSubmit()}
                            size="large"
                            type="primary"
                        >
                            {t('COOKIE.PublicBanner')}
                        </Button>
                    </div>
                </Form>
            </>
        </Modal>
    );
}
